import React, { useState, useCallback, useEffect } from "react";
import { Col, Input, Label, Row, TabPane, Spinner, Button } from "reactstrap";
import { toast } from "react-toastify";
import { APIClient } from "../../../../helpers/api_helper";

const apiClient = new APIClient();

const TabPerfil = () => {
  const [loading, setLoading] = useState(false);
  const [isEditingAddress, setIsEditingAddress] = useState(false);
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [cpf, setCpf] = useState("");
  const [situacao, setSituacao] = useState("");
  const [dataNascimento, setDataNascimento] = useState("");
  const [rg, setRg] = useState("");
  const [telefone, setTelefone] = useState("");
  const [limiteAnual, setLimiteAnual] = useState(0);
  const [verificacao, setVerificacao] = useState("");
  const [indicadoPor, setIndicadoPor] = useState("");
  const [nivelKyc, setNivelKyc] = useState("");
  const [endereco, setEndereco] = useState("");
  const [activateMati, setActivateMati] = useState(false);

  const fetchClientData = useCallback(async (user_id) => {
    const response = await apiClient.get(`/client/get-client-data/${user_id}`);

    if (response.sucesso) {
      return response.dados;
    } else {
      toast.error(response.mensagem);
      return [];
    }
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const dados = await fetchClientData(
        JSON.parse(localStorage.getItem("authUser"))?.data?._id
      );
      setNome(dados.clientData.nome_completo);
      setEmail(dados.clientData.email);
      setCpf(dados.clientData.cpf_cnpj);
      setSituacao(dados.clientData.status_cpf);
      setDataNascimento(formatDate(dados.clientData.nascimento));
      setRg(dados.clientData.rg);
      setTelefone(formatPhoneNumber(dados.clientData.telefone));
      setLimiteAnual(dados.clientData.limite_anual_brl);
      setVerificacao(
        dados.clientData.metamap_status_verification === "rejected"
          ? "Reprovado"
          : dados.clientData.metamap_status_verification === "verified"
          ? "Aprovado"
          : dados.clientData.metamap_status_verification === "reviewNeeded"
          ? "Revisão Pendente"
          : "Aguardando"
      );
      setIndicadoPor(
        dados.clientData.indicacao === "fort"
          ? "Sem Indicação"
          : dados.clientData.indicacao
      );
      setNivelKyc(dados.kycNome);
      setEndereco(dados.clientData.endereco);
      setActivateMati(
        dados.clientData.metamap_status_verification !== "rejected" &&
          dados.clientData.metamap_status_verification !== "verified" &&
          dados.clientData.metamap_status_verification !== "reviewNeeded"
      );
      setLoading(false);
    };
    fetchData();
  }, [fetchClientData]);

  const getStatusColor = (status) => {
    switch (status) {
      case "Aprovado":
        return "darkgreen";
      case "Revisão Pendente":
        return "darkorange";
      case "Aguardando":
        return "darkblue";
      case "Reprovado":
        return "darkred";
      default:
        return "inherit";
    }
  };

  const formatCurrency = (value) => {
    if (!value) {
      return "R$ 0,00";
    }
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(value);
  };

  const formatPhoneNumber = (phoneNumber) => {
    if (!phoneNumber || !phoneNumber.startsWith("55")) {
      return phoneNumber;
    }

    const formattedNumber = phoneNumber.replace(
      /^(\d{2})(\d{2})(\d{1})(\d{4})(\d{4})$/,
      "+$1 ($2) $3 $4-$5"
    );
    return formattedNumber;
  };

  const formatDate = (dateString) => {
    if (!dateString) {
      return "";
    }

    const [year, month, day] = dateString.split("-");
    return `${day}/${month}/${year}`;
  };

  const handleKycCompletion = async () => {
    setLoading(true);
    const user_id = JSON.parse(localStorage.getItem("authUser"))?.data?._id;
    
    const response = await apiClient.post('/mykyc', { user_id });

    if (response.sucesso && response.dados?.url) {
      try {
        const url = new URL(response.dados.url);
        window.open(url.toString(), "_self", "noopener,noreferrer");
      } catch (error) {
        toast.error("URL de KYC inválida");
      }
    } else {
      toast.error(response.mensagem || "Erro ao iniciar processo de KYC");
    }

    setLoading(false);
  };

  const handleAddressEdit = async () => {
    if (!isEditingAddress) {
      setIsEditingAddress(true);
      return;
    }

    setLoading(true);
    const user_id = JSON.parse(localStorage.getItem("authUser"))?.data?._id;
    
    const response = await apiClient.put(`/client/editar-endereco/${user_id}`, { endereco });

    if (response.sucesso) {
      toast.success(response.mensagem || "Endereço atualizado com sucesso");
      setIsEditingAddress(false);
    } else {
      toast.error(response.mensagem || "Erro ao atualizar endereço");
    }

    setLoading(false);
  };

  return (
    <TabPane tabId="1">
      {activateMati ? (
        <Row>
          <Col
            lg={12}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              paddingBottom: "20px",
            }}
          >
            <Button 
              color="success" 
              onClick={handleKycCompletion}
              disabled={loading}
            >
              Completar KYC
            </Button>
          </Col>
        </Row>
      ) : null}
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            padding: "20px",
          }}
        >
          <Spinner height={100} width={100} />
        </div>
      ) : (
        <Row>
          <Col lg={6}>
            <div className="mb-3">
              <Label className="form-label">Nome Completo</Label>
              <Input
                disabled
                readOnly
                type="text"
                className="form-control"
                defaultValue={nome}
              />
            </div>
          </Col>
          <Col lg={6}>
            <div className="mb-3">
              <Label className="form-label">E-mail</Label>
              <Input
                disabled
                readOnly
                type="email"
                className="form-control"
                defaultValue={email}
              />
            </div>
          </Col>
          <Col lg={6}>
            <div className="mb-3">
              <Label className="form-label">CPF</Label>
              <Input
                disabled
                readOnly
                type="text"
                className="form-control"
                defaultValue={cpf}
              />
            </div>
          </Col>
          <Col lg={6}>
            <div className="mb-3">
              <Label className="form-label">Situação do CPF</Label>
              <Input
                disabled
                readOnly
                type="text"
                className="form-control"
                defaultValue={situacao}
              />
            </div>
          </Col>

          <Col lg={6}>
            <div className="mb-3">
              <Label className="form-label">RG</Label>
              <Input
                disabled
                readOnly
                type="text"
                className="form-control"
                defaultValue={rg}
              />
            </div>
          </Col>
          <Col lg={6}>
            <div className="mb-3">
              <Label className="form-label">Nascimento</Label>
              <Input
                disabled
                readOnly
                type="text"
                className="form-control"
                defaultValue={dataNascimento}
              />
            </div>
          </Col>
          <Col lg={6}>
            <div className="mb-3">
              <Label className="form-label">Telefone</Label>
              <Input
                disabled
                readOnly
                type="text"
                className="form-control"
                defaultValue={telefone}
              />
            </div>
          </Col>
          <Col lg={6}>
            <div className="mb-3">
              <Label className="form-label">Limite Mensal</Label>
              <Input
                disabled
                readOnly
                type="text"
                className="form-control"
                defaultValue={formatCurrency(limiteAnual / 12)}
              />
            </div>
          </Col>
          <Col lg={6}>
            <div className="mb-3">
              <Label className="form-label">Limite Anual</Label>
              <Input
                disabled
                readOnly
                type="text"
                className="form-control"
                defaultValue={formatCurrency(limiteAnual)}
              />
            </div>
          </Col>
          <Col lg={6}>
            <div className="mb-3">
              <Label className="form-label">Verificação KYC</Label>
              <Input
                disabled
                readOnly
                type="text"
                className="form-control"
                style={{ color: getStatusColor(verificacao) }}
                defaultValue={verificacao}
              />
            </div>
          </Col>
          <Col lg={6}>
            <div className="mb-3">
              <Label className="form-label">Indicado Por</Label>
              <Input
                disabled
                readOnly
                type="text"
                className="form-control"
                defaultValue={indicadoPor}
              />
            </div>
          </Col>
          <Col lg={6}>
            <div className="mb-3">
              <Label className="form-label">Nível KYC</Label>
              <Input
                disabled
                readOnly
                type="text"
                className="form-control"
                defaultValue={nivelKyc}
              />
            </div>
          </Col>
          <Col lg={12}>
            <div className="mb-3 pb-2">
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                <Label className="form-label">Endereço</Label>
                <Button 
                  color={isEditingAddress ? "success" : "primary"}
                  size="sm"
                  onClick={handleAddressEdit}
                  disabled={loading}
                >
                  {isEditingAddress ? "Salvar" : "Editar Endereço"}
                </Button>
              </div>
              <textarea
                className="form-control"
                id="exampleFormControlTextarea"
                disabled={!isEditingAddress}
                readOnly={!isEditingAddress}
                rows="3"
                value={endereco}
                onChange={(e) => setEndereco(e.target.value)}
              ></textarea>
            </div>
          </Col>
        </Row>
      )}
    </TabPane>
  );
};

export default TabPerfil;
